import L from 'leaflet'
import { FC, memo, useEffect, useState } from 'react'
import ReactDOM from 'react-dom'
import { useMap } from 'react-leaflet'

const POSITION_CLASSES = {
  bottomleft: 'leaflet-bottom leaflet-left',
  bottomright: 'leaflet-bottom leaflet-right',
  topleft: 'leaflet-top leaflet-left',
  topright: 'leaflet-top leaflet-right',
}

type CustomControlProps = {
  position?: keyof typeof POSITION_CLASSES
  children: JSX.Element
} & React.HTMLAttributes<HTMLDivElement>

const CustomControl: FC<CustomControlProps> = ({
  position = 'topright',
  children,
  ...props
}) => {
  const map = useMap()
  const [container, setContainer] = useState<HTMLElement>(
    document.createElement('div'),
  )
  L.DomEvent.disableClickPropagation(container)

  useEffect(() => {
    const mapContainer = map.getContainer()
    const positionClasses = POSITION_CLASSES[position].split(' ')
    const targetDiv = mapContainer.querySelector(
      `.${positionClasses.join('.')}`,
    )

    if (targetDiv) {
      setContainer(targetDiv as HTMLElement)
    }
  }, [map, position])

  return ReactDOM.createPortal(
    <div className='leaflet-control leaflet-bar' {...props}>
      {children}
    </div>,
    container,
  )
}

export default memo(CustomControl)
